<app-processing [visible]="isFetchingPdfUrl"></app-processing>
<p-card *ngIf="catalogInformation.length > 0">
  <div class="mb-3"><strong>Insect Variant / Growth Stage</strong></div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-select
          #insectVariantSelect
          appLockInitialWidth
          [options]="insectsVariantsConcatenated"
          [(ngModel)]="insectItem.insectVariantId"
          fluid="true"
          inputId="insectVariant"
          data-testid="insectVariant"
          optionLabel="label"
          optionValue="value"
          filter="true"
          [filterBy]="'searchText'"
          appendTo="body"
          filterPlaceholder="Search Insect Variant"
          class="required insect-variant-select"
          [disabled]="editingInstance"
          [style]="{ 'width': '100%', 'max-width': '100%' }"
          [panelStyle]="{ 'width': 'max-content', 'min-width': '400px' }"
          [pTooltip]="getSelectedVariantTooltip()"
          tooltipPosition="top"
          (onChange)="mapGrowthStages($event)">
          <ng-template let-variant pTemplate="item">
            <div class="flex align-items-center" [pTooltip]="variant.label" tooltipPosition="right">
              <span>{{ variant.label }}</span>
            </div>
          </ng-template>
        </p-select>
        <label for="insectVariant">Insect Variant</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-select
          #growthStageSelect
          appLockInitialWidth
          fluid="true"
          inputId="growthStage"
          [(ngModel)]="insectItem.insectGrowthStageId"
          [options]="insectGrowthStages"
          data-testid="insectGrowthStage"
          optionLabel="GrowthStageName"
          optionValue="InsectGrowthStageId"
          class="required"
          appendTo="body"
          (onChange)="emitInsectItem()"
          [disabled]="growthStageDisabled || editingInstance"></p-select>
        <label for="growthStage">Growth Stage</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-inputnumber
          [(ngModel)]="insectItem.quantity"
          class="required"
          [useGrouping]="false"
          inputId="quantity"
          data-testid="quantity"
          [min]="1"
          (ngModelChange)="emitInsectItem()" />
        <label for="quantity">Number of Insects</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <p-floatlabel variant="on">
        <p-select
          #permitSelect
          appLockInitialWidth
          fluid="true"
          [(ngModel)]="insectItem.permitId"
          [options]="permits"
          inputId="permits"
          data-testid="insectPermit"
          optionLabel="name"
          optionValue="id"
          filter="true"
          appendTo="body"
          filterPlaceholder="Search Permit"
          class="required"
          (onChange)="permitChange($event)"></p-select>
        <label for="permits">Permit</label>
      </p-floatlabel>
      <a
        [href]="selectedPermit.pdfUrl"
        target="_blank"
        download="{{ selectedPermit.fileName }}"
        *ngIf="selectedPermit !== undefined && selectedPermit.uploadId !== null && selectedPermit.uploadId !== '' && selectedPermit.pdfUrl !== null"
        class="ml-2 mt-1 text-blue-500 hover:text-blue-700"
        attr.data-testid="permitPdfLink{{ selectedPermit.id }}">
        {{ selectedPermit.fileName || 'View PDF' }}
      </a>
    </div>
  </div>
</p-card>
